'use client';

import { c as _c } from "react/compiler-runtime";
import { ProgressiveBlur } from '@/components/ui/progressive-blur';

/**
 * Softens grid content into the page chrome at both ends of the scroll area.
 *
 * The top edge is the one that matters: the toolbar and category bar are
 * `fixed` with nothing behind them, so items scrolling underneath render
 * straight through the labels. The band covers the bar and stops just past
 * it — running it to the grid's full top padding reaches items that are
 * already clear of the chrome.
 *
 * Blur only, no scrim. A gradient behind this dims the garments as much as it
 * separates them from the chrome, and on a wall of product shots that reads as
 * a washed-out band rather than depth.
 *
 * Renders nothing on its own — the caller positions it inside the `relative`
 * view root, as a sibling *after* the scroll container so `backdrop-filter`
 * has the grid beneath it to blur.
 */

// backdrop-filter is `layerIndex * intensity` px, so the strongest layer lands
// at ~3.5px. The original 0.33 topped out near 1px, which disappeared against
// product photography.
const BLUR_INTENSITY = 0.7;
const BLUR_LAYERS = 6;
export function GridScrollFade(t0) {
  const $ = _c(9);
  const {
    axis: t1
  } = t0;
  const axis = t1 === undefined ? "vertical" : t1;
  const horizontal = axis === "horizontal";
  const t2 = horizontal ? "left" : "top";
  const t3 = horizontal ? "pointer-events-none absolute inset-y-0 left-0 w-[12vw]" : "pointer-events-none absolute top-0 right-0 left-0 h-24 md:h-20";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = <ProgressiveBlur direction={t2} className={t3} blurIntensity={BLUR_INTENSITY} blurLayers={BLUR_LAYERS} />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = horizontal ? "right" : "bottom";
  const t6 = horizontal ? "pointer-events-none absolute inset-y-0 right-0 w-[12vw]" : "pointer-events-none absolute right-0 bottom-0 left-0 h-20";
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = <ProgressiveBlur direction={t5} className={t6} blurIntensity={BLUR_INTENSITY} blurLayers={BLUR_LAYERS} />;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t4 || $[7] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[6] = t4;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}